import { store } from '../store/store';
import { HttpRequest } from '../utils';

const httpRequest = new HttpRequest(store);

export const list = async ({
  carBrandId,
  carModelId,
  query,
  page = 1,
  limit = 20,
}: {
  carBrandId?: string;
  carModelId?: string;
  query?: string;
  page?: number;
  limit?: number;
}) => {
  const res = await httpRequest.get(`/api/vehicle`, {
    carBrandId,
    carModelId,
    query,
    page,
    limit,
  });
  return res;
};

export const inquire = async ({ vinOrPlateNumber }: { vinOrPlateNumber: string }) => {
  const res = await httpRequest.get(`/api/vehicle/inquire`, {
    vinOrPlateNumber: vinOrPlateNumber,
  });
  return res;
};
